import { Channel } from "./channel";

export namespace WebSocket {
  export type ServerConnection = {
    query: Record<string, string>,
    path: string,

    protocol: string,

    disconnect(reason?: number): void,
    port: Channel.Port.Uniform<string | ArrayBuffer>,

    ready: Promise<void>,
    disconnected: Promise<{ reason: number }>,
  }
  export type ClientConnection = {
    disconnect(reason?: number): void,
    port: Channel.Port.Uniform<string | ArrayBuffer>,

    ready: Promise<{ protocol: string }>,
    disconnected: Promise<{ reason: number }>,
  }

  export type Handler = (connection: ServerConnection) => void;

  export namespace ProtocolNegotiation {
    export type Request = {
      query: Record<string, string>,
      path: string,

      protocols: string[],
    }

    export type Handler = (request: Request) => string;
  }

  export type Route = {
    path: string,
    protocol: string,
    handler: Handler
  }

  export type Client = {
    connect(url: URL, protocols?: string[]): ClientConnection,
  };
}

export const WebSocket = {

  /**
   * Combine an array of routes into a single HTTP Handler, that calls
   * the relevant route handler based on their path/method.
   * 
   * @param routes A list of all routes
   * @param notFoundHandler A fallback handler that is called if there is no matched route
   * @returns Http.handler
   */
  createRoutesHandler(routes: WebSocket.Route[], notFoundHandler: WebSocket.Handler): WebSocket.Handler {
    const routeByPath = new Map<string, WebSocket.Route>(routes.map(r => [r.path, r]));

    return async (connection) => {
      const route = routeByPath.get(connection.path.slice(1));
      
      if (route) {
        return route.handler(connection);
      }

      // fallback: serve the not found handler
      return notFoundHandler(connection);
    }
  },
  createProtocolHandler(routes: WebSocket.Route[]): WebSocket.ProtocolNegotiation.Handler {
    const routeByPath = new Map<string, WebSocket.Route>(routes.map(r => [r.path, r]));

    return ({ protocols, path, query }) => {
      const route = routeByPath.get(path.slice(1));
      
      if (route) {
        // We, uh, ignore all other results
        return route.protocol;
      }
      
      return '';
    }
  }
}